export class CreateClassificationPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationPolicy",
            "baseName": "classificationPolicy",
            "type": "ClassificationPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateClassificationPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
